import React from 'react';
import { createRoot } from 'react-dom/client';
import DpitBuilderCore from './core/DpitBuilderCore';
import Dpit from './Dpit';

import Index from '../apps/TourStepEditor/Index';
import { CORE_ENGINES } from './core/constants';
import { TargetType } from '../apps/TourStepEditor/store/appMode';
import registerServiceWorker from '../apps/TourStepEditor/registerServiceWorker';

export default class DpitBuilder extends Dpit {
	constructor(mainCfg, tourCfg) {
		if (mainCfg.dpDebugEn) console.log('[dpit] INIT DpitBuilder');
		super(mainCfg, tourCfg);
		if (mainCfg.builderMode === TargetType.MOBILE_MENU) this.createBuilder();
	}

	isStepsEnough2Start() {
		return true;
	}

	/*createCore() {

		const core = new DpitBuilderCore(this.wrapEl, this.mainCfg, this.tourCfg);
		core.setOptions(this.getIntroCoreOptions());
		return Promise.resolve(core);
	}*/
	afterIntroCoreInit() {
		super.afterIntroCoreInit();
		this.createBuilder();
		// for future
	}

	processUserVisit() {
		// Don't work with user visits in builder
	}


	async createCore() {
		const coreModuleName = (this.tourCfg.theme === 'sticky') ? CORE_ENGINES.builderSticky : CORE_ENGINES.builder;
		const module = await import(/* webpackChunkName: "[request]" */ `./core/${coreModuleName}`);
		const core = new module.default(this.wrapEl, this.mainCfg, this.tourCfg);
		core.setOptions(this.getIntroCoreOptions());
		return Promise.resolve(core);
	}

	createBuilder() {
		const container = DpitBuilderCore.initBuilderContainer(this.wrapEl);
		const root = createRoot(container);
		root.render(
			<Index
				mainCfg={this.mainCfg}
				tourCfg={this.tourCfg}
				core={this.core}
				secondLayerIntroModule={this}
			/>
		);
		if (!this.mainCfg.dpDebugEn) registerServiceWorker();
	}
}
